<mat-chip-grid #tagGrid aria-label="Tags" [formControl]="noteTagsCtrl">
  @for (tag of activityTags(); track tag) {
    <mat-chip-row [value]="tag" (removed)="removeTag($event)" matTooltip="{{ tag }}">
      {{ tag }}
      <button matChipRemove>
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
  }
  <input
    placeholder="{{ 'ACTIVITY_LOGGER.ADD_TAGS' | translate }}"
    [matChipInputFor]="tagGrid"
    [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
    [matAutocomplete]="tagAutocomplete"
    [formControl]="tagsCtrl"
    (matChipInputTokenEnd)="addNewTag($event)"
    (blur)="addTagOnBlur()"
    />
</mat-chip-grid>
<mat-autocomplete #tagAutocomplete="matAutocomplete" (optionSelected)="selectedTag($event)">
  @if (filteredTags$ | async; as tags) {
    @for (tag of tags; track tag) {
      <mat-option [value]="tag">
        {{ tag }}
      </mat-option>
    }
  }
</mat-autocomplete>
